import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class BalanceSheetapiService {

  constructor(private http: HttpClient, private configService: ConfigurationService) { }
  private apiUrl = this.configService.getAPIBaseUrl(); // Base URL for your API


  getBalanceSheet(id:any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/BalanceSheet/GetBalanceSheettemplate`;
    return this.http.get<any>(url+"?id="+id);
  }
  sentmail(TemplatesData: any, IsFirstAcctPeriod?:any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Email_Configuration/sendMails?`;
    //return this.http.get(url, { responseType: 'text' });
    return this.http.post(url, TemplatesData, { responseType: 'text' });
  }
}
